<template>
  <div class="mt-8 min-h-[400px]">
    <p class="font-bold text-xl pb-2 tracking-tight text-gray-900">Recueil du consentement</p>
    <div>
      <p>
        Nous avons envoyé au client un code de 4 chiffres par SMS et par email. Veuillez renseigner le code afin de
        finaliser l'adhésion.
      </p>
    </div>
    <div class="px-72 py-12">
      <input
        type="text"
        name="consent-code"
        id="consent-code"
        class="focus:ring-primary focus:border-primary block w-full rounded-lg border-gray-300 text-5xl text-center"
        placeholder="XXXX"
        v-model="consentCode"
      />
    </div>
    <div class="flex justify-center">
      <PrimaryButton :loading="isVerifyingConsentCode" @click="verifyConsentCode">Confirmer le paiement</PrimaryButton>
    </div>
    <div class="mt-2 flex justify-center">
      <span
        class="text-primary-dark underline"
        :class="isSendingConsentCode ? 'opacity-60 cursor-not-allowed pointer-events-none' : 'cursor-pointer'"
        @click="sendConsentCode"
      >
        Renvoyer le code
      </span>
    </div>
    <div class="mt-2 flex justify-center">
      <span class="text-gray-700 text-sm italic underline cursor-pointer" @click="reportMissingCode">
        Le client n'a pas reçu le code
      </span>
    </div>
    <div class="mt-4 flex justify-center">
      <SecondaryButton @click="showQRCodeViaWhatsApp">Demander le code via WhatsApp</SecondaryButton>
    </div>
    <div v-if="showQRCode && qrCodeDataUrl" class="mt-6 flex flex-col items-center">
      <p class="text-sm text-gray-600 mb-2 text-center">
        Si le client n’a pas reçu le SMS ou l’e-mail :
        <span class="font-bold">demandez-lui de scanner ce QR code</span>
        et
        <span class="font-bold">d’envoyer le message WhatsApp prérempli</span>
        afin de recevoir immédiatement son code de confirmation.
      </p>
      <img :src="qrCodeDataUrl" alt="QR Code WhatsApp" class="w-48 h-48" />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { PrimaryButton, SecondaryButton } from "@estaly/ui";

export default {
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
    isVerifyingConsentCode: {
      type: Boolean,
      default: false,
    },
    isSendingConsentCode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => {
    return {
      consentCode: "",
      qrCodeDataUrl: null,
      showQRCode: false,
    };
  },

  methods: {
    async generateQRCode() {
      try {
        const phone = "19378836516"; // numéro WhatsApp Estaly
        const leadId = this.lead.id;

        const message = encodeURIComponent(
          `Je souhaite recevoir mon code de confirmation Estaly pour le dossier n°${leadId}`,
        );

        const url = `https://wa.me/${phone}?text=${message}`;

        this.qrCodeDataUrl = await QRCode.toDataURL(url);
      } catch (error) {
        console.error("Erreur lors de la génération du QR code:", error);
      }
    },
    verifyConsentCode() {
      if (this.isVerifyingConsentCode) return;
      this.$emit("verifyConsentCode", this.consentCode);
    },
    sendConsentCode() {
      if (this.isSendingConsentCode) return;
      this.$emit("sendConsentCode");
    },
    reportMissingCode() {
      this.$emit("reportMissingCode");
    },
    async showQRCodeViaWhatsApp() {
      if (!this.qrCodeDataUrl) await this.generateQRCode();

      this.showQRCode = true;
    },
  },
};
</script>
